import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppContextProvider from "./AppContextProvider";
// LAYOUT, PAGE IMPORTS
import Layout from "./layout/Layout";
import LandingPage from "./pages/LandingPage";
import KapcsolatPage from "./pages/KapcsolatPage";
import PdfVieWerPage from "./pages/PdfVieWerPage";
import GaleryPage from "./pages/GaleryPage";
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminLandingPage from "./pages/admin/AdminLandingPage";
import FileUpload from "./pages/admin/FileUpload";
import NewsPage from "./pages/admin/NewsPage";
import Galeria from "./pages/admin/Galeria";

import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.mjs`;

function App() {
  return (
    <AppContextProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path="" element={<LandingPage />} />
            <Route path="/home" element={<LandingPage />} />
            <Route path="/content" element={<PdfVieWerPage />} />
            <Route path="/kapcsolat" element={<KapcsolatPage />} />
            <Route path="/galerypage" element={<GaleryPage />} />
          </Route>
          <Route path="/admin" element={<AdminLandingPage />}>
            <Route path="fileupload" element={<FileUpload />} />
            <Route path="news" element={<NewsPage />} />
            <Route path="galery" element={<Galeria />} />
          </Route>

          <Route path="admin/login" element={<AdminLoginPage />} />
        </Routes>
      </BrowserRouter>
    </AppContextProvider>
  );
}

export default App;
